(function($) {
  window.NestedFormEvents = function() {
    this.addFields = $.proxy(this.addFields, this);
    this.removeFields = $.proxy(this.removeFields, this);
  };

  NestedFormEvents.prototype = {
    addFields: function(e) {
      // Prevent the default action
      e.preventDefault();
      var link      = e.currentTarget;
      var assoc     = $(link).data('association');
      var blueprint = $('#' + $(link).data('blueprint-id'));
      var content   = blueprint.data('blueprint');

      // Make the context correct by replacing new_<parents> with the generated ID
      var context = ($(link).closest('.fields').closestChild('input, textarea, select').eq(0).attr('name') || '').replace(/\[[a-z_]+\]$/, '');

      // context will be something like this for a brand new form:
      // project[tasks_attributes][new_1255929127459][assignments_attributes][new_1255929128105]
      // or for an edit form:
      // project[tasks_attributes][0][assignments_attributes][new_1255929128105]
      if (context) {
        var current = content.match(new RegExp('\\[([a-z_]+)\\]\\[new_' + assoc + '\\]'));
        if (current) {
          context = context.replace(new RegExp('\\[' + current[1] + '\\]\\[(new_)?\\d+\\]$'), '');
        }

        var parent_names = context.match(/[a-z_]+_attributes(?=\]\[(new_)?\d+\])/g) || [];
        var parent_ids   = context.match(/[0-9]+/g) || [];

        for(var i = 0; i < parent_names.length; i++) {
          if(parent_ids[i]) {
            content = content.replace(
              new RegExp('(_' + parent_names[i] + ')_.+?_', 'g'),
              '$1_' + parent_ids[i] + '_');

            content = content.replace(
              new RegExp('(\\[' + parent_names[i] + '\\])\\[.+?\\]', 'g'),
              '$1[' + parent_ids[i] + ']');
          }
        }
      }

      var regexp  = new RegExp('new_' + assoc, 'g');
      var new_id  = this.newId();
      content     = $.trim(content.replace(regexp, new_id));

      var field = this.insertFields(content, assoc, link);
      // bubble up event upto document (with new namespace)
      field.trigger('nested:fieldAdded');
      return false;
    },

    newId: function() {
      return new Date().getTime();
    },

    insertFields: function(content, assoc, link) {
      var target = $(link).data('target');
      if (target) {
        return $(content).appendTo($(target));
      } else {
        return $(content).insertBefore(link);
      }
    },

    removeFields: function(e) {
      e.preventDefault();
      var link = e.currentTarget;
      var hiddenField = $(link).prev('input[type=hidden]');
      hiddenField.val('1');
      var target = $(link).closest('.fields');
      target.hide();
      target.trigger('nested:fieldRemoved');
      return false;
    }
  };

  window.nestedFormEvents = new NestedFormEvents();
  $(document).delegate('.add_nested_fields', 'click', nestedFormEvents.addFields);
  $(document).delegate('.remove_nested_fields', 'click', nestedFormEvents.removeFields);
})(jQuery);

// jQuery Closest Child plugin
(function($) {
  $.fn.closestChild = function(selector) {
    var $found = $(),
        $currentSet = this; // Current place
    while ($currentSet.length) {
      $found = $currentSet.filter(selector);
      if ($found.length) break;  // At least one match found
      $currentSet = $currentSet.children(); // Go down one level
    }
    return $found.first(); // Return first match of the collection
  };
})(jQuery);